module.exports = __webpack_public_path__ + "img/intro-cv-image-fr.da54b1ad.png";